import Swal from 'sweetalert2';
import '../styles/supportActionSwal.css';

const BASE_CLASSES = {
  popup: 'swal-support-action-popup',
  title: 'swal-support-action-title',
  htmlContainer: 'swal-support-action-html',
  actions: 'swal-support-action-actions',
  confirmButton: 'swal-support-action-confirm',
  cancelButton: 'swal-support-action-cancel',
  validationMessage: 'swal-support-action-validation',
};

function joinClasses(...parts) {
  return parts.filter(Boolean).join(' ');
}

/**
 * Aplica tema visual unificado a diálogos SweetAlert de acciones de tareas.
 * @param {import('sweetalert2').SweetAlertOptions} options
 * @param {{ dangerConfirm?: boolean, withIcon?: boolean }} themeOpts
 */
export function mergeActionSwalTheme(options = {}, themeOpts = {}) {
  const { dangerConfirm = false, withIcon = false } = themeOpts;
  const prev = options.customClass ?? {};

  const confirmBase = dangerConfirm
    ? joinClasses(BASE_CLASSES.confirmButton, 'swal-support-action-confirm--danger')
    : BASE_CLASSES.confirmButton;

  const popupClasses = joinClasses(
    BASE_CLASSES.popup,
    withIcon && 'swal-support-action-popup--icon',
    prev.popup
  );

  const themed = {
    buttonsStyling: false,
    ...options,
    customClass: {
      ...BASE_CLASSES,
      ...prev,
      popup: popupClasses,
      title: joinClasses(BASE_CLASSES.title, prev.title),
      htmlContainer: joinClasses(BASE_CLASSES.htmlContainer, prev.htmlContainer),
      actions: joinClasses(BASE_CLASSES.actions, prev.actions),
      confirmButton: joinClasses(confirmBase, prev.confirmButton),
      cancelButton: joinClasses(BASE_CLASSES.cancelButton, prev.cancelButton),
      validationMessage: joinClasses(BASE_CLASSES.validationMessage, prev.validationMessage),
    },
  };

  if (dangerConfirm) {
    delete themed.confirmButtonColor;
  }
  if (options.showCancelButton) {
    delete themed.cancelButtonColor;
  }

  return themed;
}

export function actionSwal(options, themeOpts) {
  const withIcon = Boolean(options.icon && options.icon !== '');
  return Swal.fire(mergeActionSwalTheme(options, { ...themeOpts, withIcon }));
}

export function actionSwalDanger(options) {
  return actionSwal(options, { dangerConfirm: true });
}

/**
 * Spinner en el modal ya abierto (no abre otro Swal).
 * Preferir `runActionInPreConfirm` en uiHandlers; esto queda como respaldo.
 */
export function showActionLoading(
  title = 'Procesando…',
  detail = 'Actualizando los datos en el sistema. Espere un momento.'
) {
  if (Swal.isVisible()) {
    Swal.update({
      title,
      html: `<p class="swal-support-action-loading-text">${detail}</p>`,
      showConfirmButton: false,
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    Swal.showLoading();
    return Promise.resolve();
  }
  return actionSwal({
    title,
    html: `<p class="swal-support-action-loading-text">${detail}</p>`,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}
